export default "__VITE_ASSET__g$tYjVdM__"